module.exports = __webpack_public_path__ + "static/media/katie_cropped.16b6d979.jpg";